export default __webpack_public_path__ + "static/media/radio.c47ee82f.png";